// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo_logoContainer__2gzvt","img":"Logo_img__1dtCc"};